import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['inputFeeNextButton', 'monthlyFeeMin', 'monthlyFeeMax']

  className () {
    return this.element.dataset.classname
  }

  inputFeeNextButtonStatus (e) {
    const selectedValue1 = this.monthlyFeeMinTarget.value
    const selectedValue2 = this.monthlyFeeMaxTarget.value
    let setButtonStatus

    if ((((selectedValue1 * 1 - selectedValue2 * 1) > 0 && !(selectedValue1 === '-1' || selectedValue2 === '-1')))) {
      setButtonStatus = false
    } else if (selectedValue1 === '-1' && selectedValue2 === '-1') {
      setButtonStatus = false
    } else {
      setButtonStatus = true
    }

    if (setButtonStatus) {
      this.inputFeeNextButtonTarget.classList.remove(`${this.className()}::disabled`)
    } else {
      this.inputFeeNextButtonTarget.classList.add(`${this.className()}::disabled`)
    }

    window.gtagEvent('gtm.click', '', 'list_price_limit_changed')
  }
}
